import { render } from "./CardInformativo.vue?vue&type=template&id=c3d6736a&scoped=true"
import script from "./CardInformativo.vue?vue&type=script&lang=js"
export * from "./CardInformativo.vue?vue&type=script&lang=js"

import "./CardInformativo.vue?vue&type=style&index=0&id=c3d6736a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d6736a"]])

export default __exports__